import React, { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import Navbar from "../Navigation/Navigation";
import Footer from "../Footer/Footer";
import ContactStack from "../ContactPage/ContactPage";
import ClientSection from '../About/ClientSection/ClientSection';
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import whatsappImg from "../../assets/whatsapp.png";
import Testimonials from "../Testimonials/Testimonials";
import "./Team.css";


const Team = () => {
    const [showContact, setShowContact] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);


    return (
        <div className="team-page-wrapper">
            <Navbar />


                    <ClientSection />
                  
                    <Testimonials/>
              
            <Footer onContactClick={() => setShowContact(true)} />

            <AnimatePresence>
                {showContact && (
                    <ContactStack onClose={() => setShowContact(false)} />
                )}
            </AnimatePresence>

            <ScrollToTop />

            {/* Fixed WhatsApp Icon */}
            <a
                href="https://wa.me/7540001028"
                className="whatsapp-float"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                    position: "fixed",
                    bottom: "30px",
                    right: "20px",
                    zIndex: 9999,
                    cursor: "pointer",
                }}
            >
                <img
                    src={whatsappImg}
                    alt="WhatsApp Chat"
                    style={{
                        width: "60px",
                        height: "60px",
                        borderRadius: "50%",
                    }}
                />
            </a>
        </div>
    );
};

export default Team;
